import {
  AirValidationBySectorResponse,
  AirValidationResponse,
  AirValidationResponseError
} from '@app/entities/air-validation.response';
import { ActivitiesValidateResponse } from '@activities/entities/activities-booking';
import { VehicleValidateResponse } from '@autos/entities/vehicle-validate.response';
import { HotelValidationResponse } from '@booking/entities/hotel-validation.response';

export const bookingFeatureName = 'bookingModule';

export type UiBookingState = Readonly<{
  isLoadingBooking: boolean,
  isLoadingValidation: boolean,
  paxSectionReady: boolean,
  bookingReady: boolean,
  isChurningExceded: boolean,
  exchangeRate: number,
  hasBookingError: boolean,
  proceedToCheckout: boolean,
}>;

export type BookingState = Readonly<{
  validationError: AirValidationResponseError,
  airValidation: AirValidationResponse,
  airValidationBySector: AirValidationBySectorResponse,
  hotelValidation: HotelValidationResponse,
  autoValidation: VehicleValidateResponse,
  activitiesValidation: ActivitiesValidateResponse,
  ui: UiBookingState,
  countries: string[],
}>;
